import React, { useState } from 'react'

import { addDays, subDays } from 'date-fns'
import { useFormContext } from 'react-hook-form'
import { Stack, Box } from '@mui/material'
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'

import { get } from 'utils/lodash'
import { IconButton } from 'components/route-manager/RouteManagerAppBar/RouteManagerDatePicker'

import DatePickerMenu from './DatePickerMenu'
import DisplayField from './DisplayField'
import { shortcutsItems } from './settings'

const ConfiguredServiceDatePickerSection = () => {
  const [dateRangeState, setDateRangeState] = useState({ anchorEl: null, dateRange: [] })
  const { watch, setValue } = useFormContext()
  const startDate = watch('startDate')
  const endDate = watch('endDate')
  const anchorEl = get(dateRangeState, 'anchorEl', null)
  const dateRange = get(dateRangeState, 'dateRange', [])

  const handlePrevClick = () => {
    setValue('startDate', subDays(startDate, 7))
    setValue('endDate', subDays(startDate, 1))
  }

  const handleNextClick = () => {
    setValue('startDate', addDays(endDate, 1))
    setValue('endDate', addDays(endDate, 7))
  }

  const handleCalendarOpen = event => {
    event.stopPropagation()
    setDateRangeState({ anchorEl: event.currentTarget, dateRange: [startDate, endDate] })
  }

  const handleCalendarClose = () => {
    setDateRangeState({ anchorEl: null, dateRange: [] })
  }

  const handleCalendarChange = value => {
    setDateRangeState(prev => ({ ...prev, dateRange: value }))
  }

  const handleSave = () => {
    const newStartDate = get(dateRange, '0')
    if (!newStartDate) {
      return
    }
    setValue('startDate', newStartDate)
    const newEndDate = get(dateRange, '1')
    setValue('endDate', newEndDate || addDays(newStartDate, 6))
    handleCalendarClose()
  }

  return (
    <>
      <Box display="flex" position="absolute" top={27} alignItems="center" justifyContent="center" width="100%" zIndex={1}>
        <Stack direction="row" spacing={1} alignItems="center" justifyContent="center">
          <IconButton onClick={handlePrevClick}>
            <ArrowBackIosNewIcon sx={{ fontSize: 16 }} />
          </IconButton>
          <DisplayField startDate={startDate} endDate={endDate} onCalendarOpen={handleCalendarOpen} borderRadius="50px" />
          <IconButton onClick={handleNextClick}>
            <ArrowForwardIosIcon sx={{ fontSize: 16 }} />
          </IconButton>
        </Stack>
      </Box>

      {anchorEl && (
        <DatePickerMenu
          anchorEl={anchorEl}
          dateRange={dateRange}
          shortcutsItems={shortcutsItems}
          onCalendarChange={handleCalendarChange}
          onSave={handleSave}
          onCalendarClose={handleCalendarClose}
        />
      )}
    </>
  )
}

ConfiguredServiceDatePickerSection.propTypes = {}

export default ConfiguredServiceDatePickerSection
